<template>
  <el-container></el-container>
</template>
<script>
export default {
  name: 'googleLogin',
  data () {
    return {}
  },
  mounted () {
    let query = this.$route.query
    let accessToken = query.access_token
    if (accessToken === undefined) {
      let searchParams = new URLSearchParams(this.$route.hash)
      accessToken = searchParams.get('access_token')
    }
    let newUrl = ''
    if (query.domain === 'localhost') { // 本地测试跳转.
      newUrl = 'http://localhost:8081/login/googleLogin?access_token=' + accessToken
    } else if (query.domain === 'test.roompai.com') { // 测试环境跳转.
      newUrl = 'https://test.roompai.com/login/googleLogin?access_token=' + accessToken
    } else if (query.domain === 'test.us.roompai.com') { // 美服测试环境.
      newUrl = 'https://test.us.roompai.com/login/googleLogin?access_token=' + accessToken
    } else if (window.opener !== null && window.opener.googleInstanceCallback !== null) { // 当前环境回传数据给母窗口.
      window.opener.googleInstanceCallback(accessToken)
      window.close()
    } else { // 啥也没找到，跳转到正常的登录页面.
      let accessTokenString = this.common.linkEncode({'google_access_token': accessToken}, 'obj')
      newUrl = 'https://' + window.location.hostname + '/login/login/' + accessTokenString
    }
    if (newUrl !== '') {
      window.location.href = newUrl
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/module/googleLoginPage.vue